import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'
import ConnectMsgSuggestions from './ConnectMsgSuggestions'
import LexicoinCounter from '../dashboard_sections/LexicoinCounter'

class SendConnectRequest extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: '',
      sentNotification: false,
      error: '',
      buttonLoading: false,
    }

    this.onClose = this.onClose.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.onSendRequest = this.onSendRequest.bind(this)
    this.selectPrompt = this.selectPrompt.bind(this)
  }

  handleChange(event) {
    this.setState({
      text: event.target.value,
      error: '',
    })
  }

  onSendRequest() {
    if (this.state.buttonLoading === true) {
      return
    }

    this.setState({ buttonLoading: true })

    if (this.state.text.length < 10) {
      this.setState({
        buttonLoading: false,
        error: `Please include a message to ${this.props.requestee_name}. Tap a suggestion above for ideas.`,
      })
      return
    }

    const data = {
      requestee_id: this.props.requestee_id,
      msg: this.state.text,
      og_connection: this.props.og_connection,
    }

    $.ajax({
      url: '../requestConnection',
      data,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json',
      },
      success: () => {
        if (this.props.updateOgConnectionNames) {
          this.props.updateOgConnectionNames(this.props.requestee_name)
        }
        if (this.props.requestSent) {
          this.props.requestSent()
        }
        this.setState({
          buttonLoading: false,
          sentNotification: true,
        })
      },
      error: () => {
        this.setState({ buttonLoading: false })
        console.log('Connect request failed')
      },
    })
  }

  onClose() {
    this.props.closeRequest()
    this.setState({
      text: '',
      sentNotification: false,
      error: '',
    })
  }

  selectPrompt(text) {
    this.setState({ text, error: '' })
  }

  renderCostNote() {
    if (this.props.pro) {
      return (
        <p className="connectRequestModal__cost connectRequestModal__cost--pro">
          Free with Pro — no Lexicoin needed
        </p>
      )
    }

    return (
      <p className="connectRequestModal__cost">
        Sending a request costs 1
        {' '}
        <span className="connectRequestModal__lexicoin lexicoin" aria-hidden="true" />
        {' '}
        <span className="connectRequestModal__costPro">(Free for Pro members)</span>
      </p>
    )
  }

  renderSentState() {
    const { requestee_name } = this.props

    return (
      <StandardModal
        onClose={this.onClose}
        title="Request sent"
        size="wide"
        modalClass="connectRequestModal connectRequestModal--sent"
      >
        <div className="connectRequestModal__sent">
          <h2 className="connectRequestModal__sentTitle">Request sent!</h2>
          <p className="connectRequestModal__sentLead">
            {requestee_name} has 7 days to respond.
          </p>
          <p className="connectRequestModal__sentText">
            When {requestee_name} accepts, we’ll alert you — turn on your notifications.
          </p>
          <p className="connectRequestModal__sentText">
            After they accept, you can chat and start planning your Lex.
          </p>
          <StandardButton
            text="Close"
            size="large"
            primary={true}
            fullWidth={true}
            onClick={this.onClose}
          />
        </div>
      </StandardModal>
    )
  }

  renderForm() {
    const { requestee_name, pro, lexicoins, og_connection } = this.props

    return (
      <StandardModal
        onClose={this.onClose}
        title={`Connect with ${requestee_name}`}
        size="wide"
        modalClass="connectRequestModal"
      >
        <div className="connectRequestModal__header">
          <h2 className="connectRequestModal__title">Connect with {requestee_name}</h2>
          <div className="connectRequestModal__headerMeta">
            {pro
              ? <span className="connectRequestModal__proBadge">Pro</span>
              : <LexicoinCounter lexicoins={lexicoins} />}
          </div>
        </div>

        <ConnectMsgSuggestions
          selectPrompt={this.selectPrompt}
          requestee_name={requestee_name}
        />

        {this.state.error && (
          <p className="connectRequestModal__error" role="alert">
            {this.state.error}
          </p>
        )}

        <div className="connectRequestModal__compose">
          <label className="connectRequestModal__label" htmlFor="connect-request-message">
            Your message
          </label>
          <textarea
            id="connect-request-message"
            placeholder={`Introduce yourself to ${requestee_name}. Why are you learning a language, and when would you like to meet?`}
            className="connectRequestModal__textarea"
            value={this.state.text}
            onChange={this.handleChange}
          />
        </div>

        {this.renderCostNote()}

        {og_connection === true && (
          <p className="connectRequestModal__ogNote">
            You and {requestee_name} chatted before Lexicoins — this request is free.
          </p>
        )}

        <div className="connectRequestModal__actions">
          <StandardButton
            text="Send request"
            size="large"
            primary={true}
            fullWidth={true}
            loading={this.state.buttonLoading}
            onClick={this.onSendRequest}
          />
        </div>
      </StandardModal>
    )
  }

  render() {
    if (this.state.sentNotification) {
      return this.renderSentState()
    }

    return this.renderForm()
  }
}

SendConnectRequest.propTypes = {
  requestee_id: PropTypes.number.isRequired,
  requestee_name: PropTypes.string.isRequired,
  closeRequest: PropTypes.func.isRequired,
  requestSent: PropTypes.func,
  lexicoins: PropTypes.number,
  og_connection: PropTypes.bool,
  pro: PropTypes.bool,
  updateOgConnectionNames: PropTypes.func,
}

SendConnectRequest.defaultProps = {
  lexicoins: 0,
  og_connection: false,
  pro: false,
}

export default SendConnectRequest
